import React from "react";

import Typography from "@mui/material/Typography";

import { Modal } from "../../modal";
import { BannerContent } from "../types";

interface Props {
  bannerContent: BannerContent;
  onClose(): void;
  open: boolean;
}

const BannerModal = ({ bannerContent, onClose, open }: Props) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={
        <span dangerouslySetInnerHTML={{ __html: bannerContent.title }} />
      }>
      <Typography
        component="div"
        sx={{
          "& > :first-of-type": { marginTop: 0 },
          "& > :last-of-type": { marginBottom: 0 },
        }}
        dangerouslySetInnerHTML={{ __html: bannerContent.content }}
      />
    </Modal>
  );
};

export default BannerModal;
